/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { GovLawScalesIcon16Light } from './GovLawScalesIcon16Light';
import { GovLawScalesIcon16Regular } from './GovLawScalesIcon16Regular';
import { GovLawScalesIcon16Solid } from './GovLawScalesIcon16Solid';
import { GovLawScalesIcon20Light } from './GovLawScalesIcon20Light';
import { GovLawScalesIcon20Regular } from './GovLawScalesIcon20Regular';
import { GovLawScalesIcon20Solid } from './GovLawScalesIcon20Solid';
import { GovLawScalesIcon24Regular } from './GovLawScalesIcon24Regular';
import { GovLawScalesIcon24Solid } from './GovLawScalesIcon24Solid';
import { GovLawScalesIcon32Regular } from './GovLawScalesIcon32Regular';
import { GovLawScalesIcon64Regular } from './GovLawScalesIcon64Regular';
var sizes = {
    16: {
        light: GovLawScalesIcon16Light,
        regular: GovLawScalesIcon16Regular,
        solid: GovLawScalesIcon16Solid,
    },
    20: {
        light: GovLawScalesIcon20Light,
        regular: GovLawScalesIcon20Regular,
        solid: GovLawScalesIcon20Solid,
    },
    24: {
        regular: GovLawScalesIcon24Regular,
        solid: GovLawScalesIcon24Solid,
    },
    32: {
        regular: GovLawScalesIcon32Regular,
    },
    64: {
        regular: GovLawScalesIcon64Regular,
    },
};
export var GovLawScalesIcon = forwardRef('GovLawScalesIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
